import { color, Text } from '@starrez/starryui9';
import React from 'react';
import styled from 'styled-components';
import { ManagedDropdown } from '../../../../../.starryUI/ManagedDropdown/ManagedDropdown';
import { strings } from '../../localization';
import { SaveForm } from './SaveForm';

export const SaveView = () => {
    return (
        <ManagedDropdown
            placement="bottom-end"
            width="446px"
            manager={(handleToggleVisible, { visible }) => (
                <SaveButton
                    type="button"
                    aria-label={strings.SaveView_Label_SaveView}
                    title={strings.SaveView_Label_SaveView}
                    onClick={handleToggleVisible}
                    visible={visible}
                >
                    <Text color={color.Blue.B60} variant="normal.bold">
                        {strings.SaveView_Label_SaveView}
                    </Text>
                </SaveButton>
            )}
        >
            <SaveForm />
        </ManagedDropdown>
    );
};

interface ISaveButton {
    visible: boolean;
}

const SaveButton = styled.button<ISaveButton>`
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
    height: 32px;
    border: 0;
    border-radius: 4px;
    padding: 0 8px;
    cursor: pointer;
    background: ${({ visible }) => visible ? color.Blue.B20 : 'transparent'};
    margin: 0 calc(8px * 1) calc(8px * 1) 0;

    * {
        cursor: pointer;
    }

    &[disabled] {
        opacity: 0.4;
        pointer-events: none;
    }

    &:hover {
        background: ${color.Blue.B20};
    }
`;
